import { Capacitor } from "@capacitor/core";

export function getPlatformShortName() {
    // get platform (ios, android, web)
    return Capacitor.isNativePlatform()
        ? Capacitor.getPlatform().substring(0, 1)
        : "w";
}
